interface TrendingItem {
  name: string;
  category: string;
  image: string;
  imageAlt: string;
}

const trendingItems: TrendingItem[] = [
  {
    name: 'Nike Dunk Low Panda',
    category: 'Sneakers',
    image: 'https://readdy.ai/api/search-image?query=Nike%20Dunk%20Low%20Panda%20sneakers%20on%20a%20minimalist%20cream%20background%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20editorial%20style%20shoe%20photography%20with%20warm%20neutral%20tones&width=600&height=600&seq=trending-sneaker-01&orientation=squarish',
    imageAlt: 'Nike Dunk Low Panda sneakers from CSSBuy spreadsheet',
  },
  {
    name: 'Essentials Fear of God Hoodie',
    category: 'Hoodies & Sweaters',
    image: 'https://readdy.ai/api/search-image?query=Essentials%20Fear%20of%20God%20hoodie%20in%20neutral%20tone%20on%20a%20warm%20cream%20background%2C%20minimalist%20fashion%20product%20photography%20with%20soft%20shadows%2C%20clean%20editorial%20style&width=600&height=600&seq=trending-hoodie-01&orientation=squarish',
    imageAlt: 'Essentials Fear of God Hoodie from CSSBuy spreadsheet',
  },
  {
    name: 'Louis Vuitton Belt Replica',
    category: 'Belts',
    image: 'https://readdy.ai/api/search-image?query=Designer%20luxury%20belt%20with%20gold%20buckle%20on%20a%20minimalist%20cream%20background%2C%20elegant%20product%20photography%20with%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic&width=600&height=600&seq=trending-belt-01&orientation=squarish',
    imageAlt: 'Designer belt from CSSBuy spreadsheet trusted sellers',
  },
  {
    name: 'Jordan 4 Black Cat',
    category: 'Sneakers',
    image: 'https://readdy.ai/api/search-image?query=Air%20Jordan%204%20Black%20Cat%20sneakers%20on%20a%20clean%20cream%20background%2C%20minimalist%20shoe%20product%20photography%20with%20soft%20lighting%2C%20editorial%20style%20with%20warm%20neutral%20tones&width=600&height=600&seq=trending-sneaker-02&orientation=squarish',
    imageAlt: 'Air Jordan 4 Black Cat from CSSBuy spreadsheet',
  },
];

export default function TrendingFinds() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-primary-950">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-14">
          <div className="flex-shrink-0">
            <span className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-xs font-semibold text-white/70 font-label tracking-wide mb-4">
              Trending Now
            </span>
          </div>
          <div className="flex-1">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              Hot Finds This Week
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trendingItems.map((item) => (
            <a
              key={item.name}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group bg-white rounded-xl overflow-hidden hover:translate-y-[-4px] transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  title={item.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-400 font-medium mb-1 font-label">{item.category}</p>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">
                  {item.name}
                </h3>
                <div className="flex items-center gap-1 mt-2 text-accent-500">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                  <span className="text-xs font-medium">View on Store</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}